/**
 * Eén vaste weergave voor wat er niet is (sessie 73): "nog niet
 * bijgehouden" (we houden het nog niet bij) of "onbekend" (we houden het
 * bij, maar voor deze klant weten we het niet). Grijs, op dezelfde plek
 * als de waarde. Nul is een leugen: waar de API `null` geeft, staat dit,
 * nooit een 0.
 */
export type NogNietSoort = "nog_niet" | "onbekend";

export function NogNiet({
  soort = "nog_niet",
  reden,
}: {
  soort?: NogNietSoort;
  /** De reden van de server; komt als title op het woord. */
  reden?: string | null;
}) {
  return (
    <span className="kk-nognniet" data-nognniet={soort} title={reden ?? undefined}>
      {soort === "onbekend" ? "onbekend" : "nog niet bijgehouden"}
    </span>
  );
}
